import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-privacy-garante-infanzia-modal',
    templateUrl: './privacy-garante-infanzia-modal.component.html',
    styleUrls: ['./privacy-garante-infanzia-modal.component.scss']
})
export class PrivacyGaranteInfanziaModalComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<PrivacyGaranteInfanziaModalComponent>) { }

    ngOnInit() {
    }

}
